import { useEffect } from 'react'
import { useAuth } from '../context/useAuth'
import { useWorkspace } from '../context/useWorkspace'
import { registerHelperWorkspaceSwitchCallback, syncHelperActiveWorkspace } from '../services/helper/helperStore'
import { FullscreenLoader } from '../components/Common/FullscreenLoader'
import { AppMobile } from '../AppMobile'
import { MobileUpdateBridge } from '../components/Mobile/MobileUpdateBridge'
import { MaintenanceBanner } from '../components/Common/MaintenanceBanner'
import { WorkspaceScopedProviders } from '../context/WorkspaceScopedProviders'

export const HelperProviderStack = () => {
  const { currentUser, isAuthLoading } = useAuth()
  const { activeWorkspaceId, isWorkspaceLoading, setActiveWorkspaceId, setAppMode, workspaceLoadingError } = useWorkspace()

  useEffect(() => {
    return registerHelperWorkspaceSwitchCallback((id) => {
      setActiveWorkspaceId(id)
      setAppMode('TEAM')
    })
  }, [setActiveWorkspaceId, setAppMode])

  useEffect(() => {
    syncHelperActiveWorkspace(activeWorkspaceId || null)
  }, [activeWorkspaceId])

  if (isAuthLoading) return (
    <FullscreenLoader waitForReady={isAuthLoading} onFinish={() => {}} />
  )
  if (!currentUser) return <AppMobile />
  if (isWorkspaceLoading && !activeWorkspaceId) return (
    <FullscreenLoader waitForReady={isWorkspaceLoading} error={workspaceLoadingError} onFinish={() => {}} />
  )
  if (!activeWorkspaceId && workspaceLoadingError) return (
    <FullscreenLoader waitForReady error={workspaceLoadingError} onFinish={() => {}} />
  )
  if (!activeWorkspaceId) return <AppMobile />

  return (
    <WorkspaceScopedProviders workspaceId={activeWorkspaceId} shell="helper">
      <AppMobile />
      <MobileUpdateBridge />
      <MaintenanceBanner />
    </WorkspaceScopedProviders>
  )
}
